import React from 'react';
import { Users } from 'lucide-react';
import { useWorkspace } from '../../workspace';
import EmptyState from '../../ui/EmptyState';

/**
 * What the console knows of who is signed in (Settings, Users and Roles). It reads the signed-in user and the organization
 * from the workspace; the backend sends no list of users and no roles (docs/c3/BACKEND.md, item 41), so it says so instead of
 * showing a list it does not have, and says what is true today: any signed-in user can approve a gated action.
 */
const YourAccount: React.FC = () => {
  const { tree, selectedOrg, loading } = useWorkspace();
  const user = tree?.user_id ?? '';
  const portfolio = selectedOrg ? Object.values(tree?.portfolios ?? {}).find((item) => item.orgs && selectedOrg.org_id in item.orgs) : undefined;

  return (
    <>
      <section className="mb-8 bg-c3-panel border border-c3-panel-bd rounded-xl p-6">
        <h2 className="text-[16px] font-semibold mb-3">You</h2>
        <dl className="c3-report-facts" aria-label="Your account">
          <div>
            <dt>User</dt>
            <dd>{user || (loading ? 'Loading…' : '—')}</dd>
          </div>
          <div>
            <dt>Organization</dt>
            <dd>{selectedOrg?.name || '—'}</dd>
          </div>
          <div>
            <dt>Portfolio</dt>
            <dd>{portfolio?.name || '—'}</dd>
          </div>
          <div>
            <dt>Role</dt>
            <dd>Any signed-in user can approve a gated action</dd>
          </div>
        </dl>
      </section>
      <section className="mb-8 bg-c3-panel border border-c3-panel-bd rounded-xl p-6">
        <h2 className="text-[16px] font-semibold mb-1">People and roles</h2>
        <EmptyState title="The list of users and roles is not available yet" icon={Users}>
          The backend does not send who else can use this organization or what each may do. Until it does, the roles cannot be listed or
          changed here.
        </EmptyState>
      </section>
    </>
  );
};

export default YourAccount;
